/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {useScope as createI18nScope} from '@canvas/i18n'
import React from 'react'
import {render, rerender} from '@canvas/react'
import axios from '@canvas/axios'
import {Heading} from '@instructure/ui-heading'
import {Spinner} from '@instructure/ui-spinner'
import {View} from '@instructure/ui-view'
import AnnouncementRow from '@canvas/announcements/react/components/AnnouncementRow'
import ready from '@instructure/ready'
import {captureException} from '@sentry/react'

const I18n = createI18nScope('announcements_on_home_page')

let _homeRoot: ReturnType<typeof render> | null = null

// @ts-expect-error TS2339 (typescriptify)
if (ENV.SHOW_ANNOUNCEMENTS) {
  ready(() => {
    const container = document.querySelector('#announcements_on_home_page')

    if (container) {
      _homeRoot = render(
        <Spinner delay={500} renderTitle={I18n.t('Loading Announcements')} size="small" />,
        container as HTMLElement,
      )

      const url = '/api/v1/announcements'

      const params = {
        // @ts-expect-error TS18048 (typescriptify)
        context_codes: [`course_${ENV.COURSE.id}`],
        // @ts-expect-error TS2339 (typescriptify)
        per_page: ENV.ANNOUNCEMENT_LIMIT || 3,
        page: '1',
        start_date: '1900-01-01',
        end_date: new Date().toISOString(),
        available_after: new Date().toISOString(),
        active_only: true,
        include: ['sections', 'sections_user_count'],
      }

      axios
        .get(url, {params})
        .then(response => {
          if (_homeRoot)
            rerender(
              _homeRoot,
              <View
                as="section"
                display="block"
                margin="0 0 medium"
                aria-label={I18n.t('Recent Announcements')}
              >
                <Heading level="h2" margin="0 0 small">
                  {I18n.t('Recent Announcements')}
                </Heading>
                {/* @ts-expect-error TS7006 (typescriptify) */}
                {response.data.map(announcement => (
                  <AnnouncementRow key={announcement.id} announcement={announcement} />
                ))}
              </View>,
            )
        })
        .catch(error => {
          console.error('Error retrieving home page announcements')
          console.error(error)
          captureException(error)
        })
    }
  })
}
